import posthog from "posthog-js";

const posthogToken = process.env.REACT_APP_POSTHOG_TOKEN;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST;

if (posthogToken && posthogHost && process.env.NODE_ENV === "production") {
  posthog.init(posthogToken, {
    api_host: posthogHost,
    person_profiles: "identified_only",
    session_recording: {
      recordCrossOriginIframes: true,
    },
    autocapture: true,
    capture_pageview: false,
  });
}

export default posthog;
